export default __webpack_public_path__ + "static/media/banner-2.8af779ef.png";